import { VehicleLocation } from 'server'
import useVehicleLocationListener from './useVehicleLocationListener'
import { useEffect, useRef } from 'react'

const useVehicleLocationStorage = (vehicleId: number): VehicleLocation[] => {
  const history = useRef<VehicleLocation[]>([])
  const updatedVehicleLocation = useVehicleLocationListener(vehicleId)
  useEffect(() => {
    if (!updatedVehicleLocation) return
    if  (history.current.length > 50) {
      history.current.shift()
    }
    history.current.push(updatedVehicleLocation)
  }, [updatedVehicleLocation])
  return history.current
}

export default useVehicleLocationStorage
